"use strict";
// Class definition
var KTWizardClientPlan = function () {
	// Base elements
	var _wizardEl;
	//var _formEl;
	var _wizard;
	//var _validations = [];
	// Private functions
	var initWizard = function () {
		var isNew = $(".new-client-plan-container").length > 0 ? true : false;
		if(!isNew){
			$('.wizard-step').css("cursor", "pointer")
		}
		// Initialize form wizard
		_wizard = new KTWizard(_wizardEl, {
			startStep: 1, // initial active step number
			clickableSteps: (isNew ? false : true) // to make steps clickable this set value true and add data-wizard-clickable="true" in HTML for class="wizard" element
		});
		// Validation before going to next page
		_wizard.on('beforeNext', function (wizard) {
			// Don't go to the next step yet
			_wizard.stop();
			//render_review_form()
			//_wizard.goNext();
			var actualStep = $(wizard)[0]["currentStep"]
			// Formulario de crear cliente
			if(actualStep == 1){
				// Se validan los campos
				var formOfert = check_inputs_form("client-plan-step-1");
				if(!formOfert){
					error_alert("Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.")
				} else {
					render_review_form()
					_wizard.goNext();
				}
			// Previsualizacion
			} else if(actualStep == 2){
				render_review_form()
				_wizard.goNext();
			}
		});
		// Change event
		_wizard.on('change', function (wizard) {
			KTUtil.scrollTop();
		});
	}

	var check_inputs_form = function (form) {
		var error = 0;
		var container = $('#'+form+'');
		var inputs = container.find($("input").not(".optional"));
		var selects = container.find($("select").not(".optional"));
		var textareas = container.find($("textarea").not(".optional"));
		var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">Debes completar este campo.</div></div>';
		var errorWithoutOptions = '<div class="fv-plugins-message-container"><div class="fv-help-block">Debes agregar al menos una opción.</div></div>';
		
		inputs.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();
			if(inputName != null && inputName != "" && typeof inputName != "undefined") {
				if (inputType == "radio" || inputType == "checkbox") {
					inputName = $(this).attr('name');
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Validamos si este input esta dentro de un checkbox list
					if(contInput.hasClass("checkbox-list")){
						// Cambia el contInput
						contInput = $(this).parent().parent().parent();
					}
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Revisa si esta activada la opcion
					var isChecked = $('input[name="'+ inputName +'"]:checked').length;
					// Si no esta chequeado
					if (isChecked == 0) {
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						contInput.find(".fv-plugins-message-container").remove()
					}
				} else if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.find(".fv-plugins-icon-container").addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.find(".fv-plugins-icon-container").append(errorMsg);
							// Le suma al contador de errores
							error++;
						// Si el input esta correcto
						} else {
							// Agrega el icono al input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.find(".fv-plugins-icon-container").addClass("has-success");
						}
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							$(this).addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.append(errorMsg);
							// Le suma al contador de errores
							error++;
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}
					}
				} else if (inputType == "file") {
					// Remueve el icono de alerta o success del input
					$(this).removeClass("is-invalid");
					$(this).removeClass("is-valid");
					// Cambia el contInput
					contInput = $(this).parent().parent().parent();
					// Remueve la clase de has-danger y has-success al contenedor del input
					contInput.removeClass("has-danger");
					contInput.removeClass("has-success");
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Si el input esta vacio
					if (!$(this).val()) {
						// Agrega el icono al input
						$(this).addClass("is-invalid");
						// Agrega la clase de has-danger al contenedor del input
						contInput.addClass("has-danger");
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				}
			}
		})

		selects.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();
			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Revisamos si el select es selectized
				var hasSelectized = $(this).hasClass("selectized")
				// Si el input esta vacio
				if ($(this).val().length == 0) {
					// Si es multiple
					if(hasMultiple) {
						// Al input con la clase tt-input le va a agregar la clase form-control para que muestre
						// el icono
						$(this).parent().find(".tt-input").addClass("form-control");
						// Cambia el icono de invalido por valido
						$(this).parent().find(".tt-input").removeClass("is-valid").addClass("is-invalid");
					}
					// Si es selectized
					if(hasSelectized) {
						// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
						// cambie el icono de valido por invalido
						$(this).parent().find(".selectize-control").removeClass("is-valid").addClass("is-invalid");
					}
					$(this).addClass("is-invalid");
					contInput.addClass("has-danger");
					contInput.append(errorMsg);
					error++;
				} else {
					// Debemos validar el formulario de preguntas para las preguntas con opciones.
					// Asi que primero detectamos que select es una preguna del formulario
					var hasQuestionSelect = $(this).hasClass("filter_question_enum_type")
					// Si es un select del formulario de preguntas
					if(hasQuestionSelect) {
						// Si la pregunta es de los tipo con opciones
						if ($(this).val() == "2" || $(this).val() == "3" || $(this).val() == "4") {
							// Obtiene las opciones que hay
							var optionsQuestion = $(this).parent().parent().parent().find(".cont-option-question-filter").children()
							// Si hay opciones se valida correctamente
							if(optionsQuestion.length > 0){
								// Agrega el icono al input
								$(this).addClass("is-valid");
								// Agrega la clase de has-success al contenedor del input
								contInput.addClass("has-success");
							// Si no tiene opciones
							} else {
								$(this).addClass("is-invalid");
								contInput.addClass("has-danger");
								contInput.append(errorWithoutOptions);
								error++;
							}
						// Si la pregunta es de un tipo texto
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}
					// De lo contrario es un select normal y se valida correctamente
					} else {
						// Si es multiple
						if(hasMultiple) {
							// Cambia el icono de invalido por valido
							$(this).parent().find(".tt-input").removeClass("is-invalid").addClass("is-valid");
						}
						// Si es selectized
						if(hasSelectized) {
							// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
							// cambie el icono de valido por invalido
							$(this).parent().find(".selectize-control").removeClass("is-invalid").addClass("is-valid");
						}
						// Agrega el icono al input
						$(this).removeClass("is-invalid").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				}
			}
		})

		textareas.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();
			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Si el input esta vacio
				if (!$(this).val()) {
					// Agrega el icono al input
					$(this).addClass("is-invalid");
					// Agrega la clase de has-danger al contenedor del input
					contInput.addClass("has-danger");
					// Muestra el mensaje de error
					contInput.append(errorMsg);
					error++;
				} else {
					// Agrega el icono al input
					$(this).addClass("is-valid");
					// Agrega la clase de has-success al contenedor del input
					contInput.addClass("has-success");
				}
			}
		})

		// Se coloca el simbolo de ok a los campos que no son obligatorios
		var inputsNotOptional = container.find($("input.optional"));
		var selectsNotOptional = container.find($("select.optional"));
		var textareasNotOptional = container.find($("textarea.optional"));

		inputsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();
			if(inputName != null && inputName != "") {
				if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Agrega el icono al input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.find(".fv-plugins-icon-container").addClass("has-success");
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				} else if (inputType == "checkbox") {
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
				}
			}
		})

		selectsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();
			if(inputName != null && inputName != "") {
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Revisamos si el select es selectized
				var hasSelectized = $(this).hasClass("selectized")
				// Si es multiple
				if(hasMultiple) {
					// Cambia el icono de invalido por valido
					$(this).parent().find(".tt-input").removeClass("is-invalid").removeClass("is-valid").addClass("is-valid");
				}
				// Si es selectized
				if(hasSelectized) {
					// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
					// cambie el icono de valido por invalido
					$(this).parent().find(".selectize-control").removeClass("is-invalid").removeClass("is-valid").addClass("is-valid");
				}
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		textareasNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();
			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		return error == 0 ? true : false;
	}

	var render_review_form = function() {
		// Esto es del primer paso del wizard
		// Asigna la infromacion a las variables
		var plan_category = $("#client-plan-form #client_plan_plan_category_id option:selected").text();
		var plan_name = $("#client-plan-form #client_plan_plan_id option:selected").data("name");
		var plan_text = $("#client-plan-form #client_plan_plan_id option:selected").text()
		var initDate = $("#client-plan-form #client_plan_init_date").val()
		var endDate = $("#client-plan-form #client_plan_end_date").val()
		
		// Reemplaza la información que existan en los elementos por el de la variable
		$("#client-plan-form #item_plan_category span").text(plan_category)
		$("#client-plan-form #item_plan span").text(plan_text)
		$("#client-plan-form #item_init_date span").text(initDate)
		$("#client-plan-form #separator_end_date").show();
		$("#client-plan-form #item_end_date").show();
		$("#client-plan-form #item_end_date span").text(endDate)
		
		deleteRenderExtra();
		
		if(plan_name == "custom"){
			var publications = $("#client-plan-form #client_plan_settings_publications").val()
			var durationOfferDays = $("#client-plan-form #client_plan_settings_duration_offer_days").val()
			var publicationsPerMonth = $("#client-plan-form #client_plan_settings_publications_per_month").val()
			var renderExtra = '<div class="separator separator-dashed my-3 separator_others"></div>\
													<div id="item_publications" class="row container"><strong class="col-sm-3">Cantidad de Publicaciones:</strong> <span class="col-sm-6">'+publications+'</span></div>\
													<div class="separator separator-dashed my-3 separator_others"></div>\
													<div id="item_duration_offer_days" class="row container"><strong class="col-sm-3">Tiempo duración publicaciones:</strong> <span class="col-sm-6">'+durationOfferDays+'</span></div>\
													<div class="separator separator-dashed my-3 separator_others"></div>\
													<div id="item_publications_per_month" class="row container"><strong class="col-sm-3">Publicaciones por mes:</strong> <span class="col-sm-6">'+publicationsPerMonth+'</span></div>';
			$("#client-plan-form .cont-answers").append(renderExtra)
		} else if(plan_name == "unlimited") {
			$("#client-plan-form #separator_end_date").hide();
			$("#client-plan-form #item_end_date").hide();
		}
	}

	var deleteRenderExtra = function() {
		$("#client-plan-form .cont-answers").find(".separator_others").remove();
		$("#client-plan-form .cont-answers").find("#item_publications").remove();
		$("#client-plan-form .cont-answers").find("#item_duration_offer_days").remove();
		$("#client-plan-form .cont-answers").find("#item_publications_per_month").remove();
	}

	var error_alert = function(msg) {
		Swal.fire({
			text: msg,
			icon: "error",
			buttonsStyling: false,
			confirmButtonText: "Aceptar",
			customClass: {
				confirmButton: "btn btn-fj-purple"
			}
		}).then(function () {
			KTUtil.scrollTop();
		});
	}

	return {
		// public functions
		init: function () {
			_wizardEl = KTUtil.getById('kt_wizard_client_plan');
			// Se obtiene el campo kt_wizard_client_plan
			var wizardClient = $('#kt_wizard_client_plan')
			// Si existe el campo
			if (wizardClient.length > 0) {
				initWizard();
			}
		}
	};
}();

// const urlParams = new URLSearchParams(window.location.search);
// const id = urlParams.get('id');
jQuery(document).ready(function () {
	KTWizardClientPlan.init();
	/*************
	* CREAR / EDITAR CLIENT PLAN (Activaciones)
	*
	* - Validacion y ejecución del formulario
	*/
	var plan = $("#client-plan-form #client_plan_plan_id")
	var initDate = $('input#client_plan_init_date')
	var endDate = $('input#client_plan_end_date')

	initDate.datepicker({
		todayBtn: "linked",
		clearBtn: true,
		language: 'es',
		format: 'yyyy-mm-dd',
		todayHighlight: true
	}).on("changeDate", function(e) {
		var selectedPlan = $("#client-plan-form #client_plan_plan_id option:selected").data("name");
		if(selectedPlan == "custom") {
			endDate.prop("disabled", false);
			endDate.datepicker('setStartDate', initDate.val());
		} else {
			var date = new Date(e.date);
			setEndDate(endDate, date, selectedPlan);
		}
	});

	endDate.datepicker({
		todayBtn: "linked",
		clearBtn: true,
		startDate: 'today',
		language: 'es',
		format: 'yyyy-mm-dd',
	});

	plan.on("change", function(e) {	
		var selectedOption = $(this).find('option:selected');
		var selectedPlan = selectedOption.data('name');
		initDate.val(null);
		initDate.datepicker('clearDates');
		endDate.val(null);
		endDate.datepicker('clearDates');
		remove_more_options();
		$("#client-plan-form #container-end-date").show();
		if(selectedPlan == "custom"){
			render_more_options();
		} else if(selectedPlan == "unlimited") {
			$("#client-plan-form #container-end-date").hide();
		}
		endDate.prop("disabled", true);
	});

	// Envio de creacion/edicion de clientes
	var clientPlan = $("#kt_wizard_client_plan #client-plan-form")
	clientPlan.on("click", ".action-submit", function(e){
		$(this).addClass("disabled").text("Enviando Información...");
		clientPlan.addClass("disabled")
		clientPlan.submit();
	})

	/*************
  	* FIN CREAR / EDITAR OFERTA
  	*/
	// Funcion para setear la fecha de fin de la oferta
	function setEndDate(endDate, date, selectedPlan){
		if(selectedPlan == "anual"){
			date.setFullYear(date.getFullYear() + 1);
			endDate.datepicker('setDate', date);
		} else if(selectedPlan == "semestral") {
			date.setMonth(date.getMonth() + 6);
			endDate.datepicker('setDate', date);
		} else if(selectedPlan == "unlimited") {
			date.setFullYear(date.getFullYear() + 100);
			endDate.datepicker('setDate', date);
		} else {
			endDate.val(null);
		}
	}

	function render_more_options() {
		var html_options = '<div id="more-activation-separator" class="separator my-10"></div>\
												<div id="more-activation-1" class="row">\
													<div class="col-xl-4">\
														<div class="form-group fv-plugins-icon-container">\
															<label for="client_plan_settings_publications">Cantidad de Publicaciones</label>\
															<input type="number" min="0" id="client_plan_settings_publications" class="form-control form-control-solid form-control-lg" name="client_plan[settings][publications]" value="" />\
															<span class="form-text text-muted">Obligatorio | Si es ilimitado colocar 0</span>\
														</div>\
													</div>\
													<div class="col-xl-4">\
														<div class="form-group fv-plugins-icon-container">\
															<label for="client_plan_settings_duration_offer_days">Tiempo duración publicaciones</label>\
															<input type="number" min="0" id="client_plan_settings_duration_offer_days" class="form-control form-control-solid form-control-lg" name="client_plan[settings][duration_offer_days]" value="" />\
															<span class="form-text text-muted">Obligatorio.</span>\
														</div>\
													</div>\
													<div class="col-xl-4">\
														<div class="form-group fv-plugins-icon-container">\
															<label for="client_plan_settings_publications_per_month">Publicaciones por mes</label>\
															<input type="number" min="0" id="client_plan_settings_publications_per_month" class="form-control form-control-solid form-control-lg" name="client_plan[settings][publications_per_month]" value="" />\
															<span class="form-text text-muted">Obligatorio | Si es ilimitado colocar 0</span>\
														</div>\
													</div>\
												</div>';
		
		remove_more_options()
		$("#client-plan-form").find("#client-plan-step-1").append(html_options);
	}

	function remove_more_options() {
		var clientPlanForm = $("#client-plan-form");
		clientPlanForm.find("#more-activation-1").remove();
		clientPlanForm.find("#more-activation-separator").remove();
	}
});